module.exports = __webpack_public_path__ + "img/lyylm1.4f0cd865.jpg";